// Training Requests

import { Component, ViewChild } from '@angular/core';
import {
  Message,
  SelectItem,
  ConfirmationService,
  ConfirmEventType,
  TreeNode,
  MenuItem,
} from 'primeng/api';
import {
  link,
  breadcrumb,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { NumberQuestion } from 'src/app/misc/component/dynamic-form/question-number';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import icons from '../../../../misc/data/icons.json';
import { TextAreaQuestion } from 'src/app/misc/component/dynamic-form/question-textarea';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { cloneDeep } from 'lodash';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-training-request',
  templateUrl: './training-request.component.html',
  styleUrls: ['./training-request.component.scss'],
})
export class TrainingRequestComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  messages: Message[] = [];
  treedata: TreeNode[] = [];
  header = this.translate('Add course requests');
  links: link[] = []
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Sustainable training'), link: '/training/task-view' },
    { name: this.translate('Add course requests'), link: '/training/request' },

  ];

  stats: stat[] = [];

  trainingRequestData: any[] = [];
  trainingType: any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  //for top filters

  status: string = 'TRAINING_CREATED';

  newBranch : boolean = false

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }


  statusOptions: any[] = [
    { name: 'PENDING', value: 'PENDING' },
    { name: 'TRAINING_CREATED', value: 'TRAINING_CREATED' },
    { name: 'APPROVED', value: 'APPROVED' },
    { name: 'REJECTED', value: 'REJECTED' },
    { name: 'REVISION', value: 'REVISION' },
  ];

  items = [
    {
      label: 'APPROVED',
      icon: ''
    },
    {
      label: 'REVISION',
      icon: ''
    }
  ];

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private orgUnits: OrgUnitsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });

    this.route.queryParams.subscribe(params => {
      const param1 = params['page'];
      if(param1 == 'new-branch'){
        this.newBranch = true
      }
    });



    this.links = [
      {
        name: this.translate('Back'),
        icon: 'pi pi-arrow-left',
        link: this.newBranch ? '/training/new-branch':'/training/task-view',
        visible: true,
      },
      // {
      //   name: this.translate('Types of training courses'),
      //   icon: 'pi pi-file-edit',
      //   link: '/training/type',
      //   visible: true,
      // },
  
    ];
    this.getTrainingTypes().then(()=>{
      this.getTreeData().then(()=>{
        this.makequestion();
        this.skelition = false;
      })

    })

  }

  private async getTrainingTypes(): Promise<void> {
    let res = await this.dataService.postData('training-type/get', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }

    this.trainingType = res.data
      .filter((item: any) => item.name === 'Unified session' || item.name === 'WEEKLY')
      .map((item: any) => ({
        _id: item._id,
        label: item.arabic,
        allowed_ou: item.allowed_ou,
        name: item.name,
        icon: `pi pi-${item.icon}`,
        value: item._id,
      }));
  }

  getTrainingRequests = async () => {
    try {

      // this.skelition = true
      this.trainingRequestData = []
      this.data = []

      console.log("status =", this.status);

      let res = await this.dataService.postData('training-req/get/', { status: this.status });
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.trainingRequestData = res.data;
      this.trainingRequestData.forEach((item: any) => {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          topic: { n: item.topic, i: item.icon },
          type: { n: item?.type?.arabic },
          description: { n: item?.description },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  getMonthy(){
    return this.trainingType.find((e:any)=>e.name == 'Unified session').allowed_ou
  }


  allowedRight = ['Ministries/Entities', 'Organisational Units', 'Branches']
  selectedTreeData : any = []
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  async getTreeData() {
    let data = await this.orgUnits.getOrgUnits()
    this.selectedTreeData = []

    //get weekly type
    let selectedid : any = this.trainingType.find((e:any)=>e.name == 'WEEKLY')

    if (selectedid.label != 'الجهات المشاركة') {
      this.selectedTreeData.push(this.findNodeByName(data, selectedid?.allowed_ou._id))
      this.selectedTreeData_orginal = cloneDeep(this.selectedTreeData);
      const uniqueTags = new Set()
      this.types.forEach((type: any) => {
        if (type && type.tag) {
          uniqueTags.add(type.tag);
        }
      });
      let uniqueTagsArray: MenuItem[] = []
      uniqueTags.forEach((item: any) => {
        if (item != "Ministries/Entities")
          uniqueTagsArray.push({ label: item });
      })
      this.selectedTreeTags = uniqueTagsArray;
      this.selectedTreeTags_current = this.selectedTreeTags[0]
      this.changeSelectedTag(this.selectedTreeTags_current);
    }
    this.filterTreeByTag("Branches");
  }


  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      if (node._id === nodeName) {
        return node;
      }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      "label": "Branches"
    };
    if (this.selectedTreeTags_current.label) {
      
    } else {
      this.selectedTreeData = null;
    }

  }

  filterTreeByTag(tag: string) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });
      this.selectedTreeData = cloneDeep(cloneitems);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    // Recursively filter children nodes
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }


  makequestion() {

    this.newBranch ?  
    
    this.questions = [
      new TextboxQuestion({
        key: 'topic',
        label: this.translate('Name'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new TreeSelectQuestion({
        key: 'ou',
        label: this.translate('Organizational unit'),
        treeOptions: this.selectedTreeData,
        order: 6,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
        filter: true,
        selectionMode: 'multiple',
      }),

      new TextAreaQuestion({
        key: 'description',
        label: this.translate('Description'),
        required: true,
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
      }),
    ]

    : 

    this.questions = [
      new TextboxQuestion({
        key: 'topic',
        label: this.translate('Name'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'type',
        label: this.translate('Types of training courses'),
        required: true,
        options: this.trainingType,
        filter: true,
        order: 2,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new TreeSelectQuestion({
        key: 'ou',
        label: this.translate('Organizational unit'),
        treeOptions: this.selectedTreeData,
        order: 6,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
        filter: true,
        visibility: "this.form.get('type').value == '64ecbe4ff6c283d49c8f3d61'"
      }),

      new TextAreaQuestion({
        key: 'description',
        label: this.translate('Description'),
        required: true,
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
      }),
    ];
  }


  //hold data to create unified training Request
  createdTrainingHolder: any
  unifiedblock = false


  closeUnified() {
    this.unifiedblock = false
    this.messages = [
      { severity: 'success', summary: this.translate('success'), detail: 'Unified Training Created Successfully' },
    ];
    this.DynamicFormComponent.resetForm();
  }

  flattenTree(root: TreeNode[]): any[] {
    const result: any[] = [];
    root.map(e => this.flattenNode(e, result))
    // this.flattenNode(root, result);
    return result;
  }

  private flattenNode(node: TreeNode, result: any[]): void {
    if((node as any)?.tag  == 'Branches' ){
      result.push((node as any)?._id);
    }
    if (node.children) {
      for (const child of node.children) {
        this.flattenNode(child, result);
      }
    }
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;

      let ous = []

      if(data?.ou){
        ous  = this.flattenTree([data?.ou])
      }
      
      
      let completedRequests = 0;
      // for unified training
      if (data.type == '64edba9b9b8555d3669790dc') {
        this.createdTrainingHolder = data
        this.unifiedblock = true
        return
      } 

      for (const ou of ous) {
        let request = {
          ou: ou,
          description: data.description,
          topic: data.topic,
          type: this.newBranch ? '654e867bb9f4c5b8996191c5' : data.type
        }

        // data.ou = data.ou._id
        let res = await this.dataService.postData('training-req/', request);
        if (res.error) {
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ];
          return;
        }
        else completedRequests++;
        if (completedRequests === ous.length) {
          this.messages = [
            { severity: 'success', summary: this.translate('success'), detail: res.msg },
          ];
          this.DynamicFormComponent.resetForm();
        }
      
      }

    } catch (error) {
      console.log(error);
    }
  };




  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      let res = await this.dataService.postData(
        'training-req/',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      let type = this.trainingType.find((e) => e._id == data.type);
      data.type = {
        _id: type._id,
        name: type.label,
        arabic: type.label,
        active: type.active,
        label: type.label,
      };
      // updating in table
      const myObject = this.data.find((item) => item['#'].n === data._id);
      if (myObject) {
        (myObject['topic'].n = data.topic),
          (myObject['description'].n = data.description);
        myObject.Type.n = data.type.name;
      }

      this.data.map((e, i) => {
        if (e['#'].n === data._id) {
          this.data[i] = myObject;
          return;
        }
      });

      this.trainingRequestData.map((e, i) => {
        if (e._id === data._id) {
          this.trainingRequestData[i] = data;
          return;
        }
      });
      console.log(this.trainingRequestData);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Comfirm message heading'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteTrainingRequest($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.trainingRequestData.find(
          (item) => item._id == $event.id
        );
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'topic',
            label: this.translate('Name'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.topic,
            className: 'col-12',
          }),

          new DropdownQuestion({
            key: 'type',
            label: this.translate('Types of training courses'),
            required: true,
            options: this.trainingType,
            filter: true,
            order: 2,
            value: this.updateData.type._id,
            className: 'col-12',
          }),

          new TextAreaQuestion({
            key: 'description',
            label:  this.translate('Description'),
            required: true,
            order: 4,
            value: this.updateData.description,
            className: 'col-12',
          }),
        ];
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteTrainingRequest = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`training-req/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('Error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item['#'].n !== id);
      this.trainingRequestData = this.trainingRequestData.filter(
        (item) => item._id !== id
      );
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('no'),
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  private updateTypeCounts(): void {
    let activeCount = this.trainingRequestData.filter(
      (e) => e.active === true
    ).length;
    let inactiveCount = this.trainingRequestData.length - activeCount;
    this.stats = [
      { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
      { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
    ];
  }
}